import React from 'react';
import DeveloperProductUncollapsed from './DeveloperProductUncollapsed';
import ResultsProductCollapsed from './ResultsProductCollapsed';
import { quizResultProducts } from '../lib/quizSteps';
import PropTypes from 'prop-types';

class DeveloperProduct extends React.Component {
  getView = () => {
    const {
      toggleProduct,
      product,
      productName,
      location,
      fptiHelper
    } = this.props;
    if (product.isCollapsed) {
      return (
        <ResultsProductCollapsed
          product={product}
          toggleProduct={toggleProduct}
          productName={productName}
          type="developerProducts"
        />
      );
    }
    const resultData = quizResultProducts(productName);
    return (
      <DeveloperProductUncollapsed
        toggleProduct={toggleProduct}
        productName={productName}
        resultData={resultData}
        location={location}
        isCompleted={product.isProductCompleted}
        fptiHelper={fptiHelper}
      />
    );
  };

  render() {
    const { shouldShowBorderBottom, product } = this.props;
    return (
      <div
        style={{
          borderBottom: shouldShowBorderBottom ? '1px dashed #CBD2D6' : 'none',
          padding: product.isCollapsed ? '0px' : '15px'
        }}
      >
        {this.getView(this.props)}
      </div>
    );
  }
}

DeveloperProduct.propTypes = {
  toggleProduct: PropTypes.func,
  product: PropTypes.object,
  productName: PropTypes.string,
  shouldShowBorderBottom: PropTypes.bool,
  location: PropTypes.object,
  fptiHelper: PropTypes.object
};

export default DeveloperProduct;
